import * as React from "react";
import AttributeCards from "./AttributeCards";
import { LinkCardContent } from "./LinkCardContent";
import LinkCards from "./LinkCards";
import CollapsibleCard from "./CollapsibleCard";

interface CardProps {
    title: string;
    content: JSX.Element;
}

const Card: React.FC<CardProps> = (props: CardProps) => {
    return (
        <div className="card">
            <h2 className="card-header">
                <span className="card-header--text">{props.title}</span>
            </h2>

            <div className="card-block">{props.content}</div>
        </div>
    );
};

export default Card;

export { AttributeCards, LinkCards, CollapsibleCard, LinkCardContent };
